// extracted by mini-css-extract-plugin
export default {"list":"RegionSelector_list__SWzaN","regionOption":"RegionSelector_regionOption__ift+4","checkbox":"RegionSelector_checkbox__nkLQG"};